import { render, staticRenderFns } from "./GoalDonation.vue?vue&type=template&id=7d360179&scoped=true&"
import script from "./GoalDonation.vue?vue&type=script&lang=js&"
export * from "./GoalDonation.vue?vue&type=script&lang=js&"
import style0 from "./GoalDonation.vue?vue&type=style&index=0&id=7d360179&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d360179",
  null
  
)

export default component.exports